import { cn } from "@/ui";

const ym = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;

// Unified month / range filter used by both the affiliate portal and the developer dashboard.
// onChange(from, to) — empty strings mean "All time".
export function AffiliateRangeFilter({ from, to, onChange, testidPrefix = "aff-filter" }) {
  const quick = (kind) => {
    const now = new Date();
    if (kind === "this") return onChange(ym(now), ym(now));
    if (kind === "l3") return onChange(ym(new Date(now.getFullYear(), now.getMonth() - 2, 1)), ym(now));
    if (kind === "year") return onChange(`${now.getFullYear()}-01`, `${now.getFullYear()}-12`);
    return onChange("", "");
  };
  const active = !!(from || to);
  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Filter</span>
      {[["this", "This month"], ["l3", "Last 3 mo"], ["year", "This year"], ["all", "All time"]].map(([k, l]) => (
        <button key={k} data-testid={`${testidPrefix}-${k}`} onClick={() => quick(k)}
          className={cn("rounded-full border px-3 py-1 text-xs font-semibold transition-colors",
            (k === "all" && !active) ? "border-primary text-foreground" : "border-border text-muted-foreground hover:border-primary hover:text-foreground")}>{l}</button>
      ))}
      <div className="flex items-center gap-1">
        <input type="month" data-testid={`${testidPrefix}-from`} value={from} onChange={(e) => onChange(e.target.value, to)} className="rounded-lg border border-input bg-background px-2 py-1 text-sm" />
        <span className="text-muted-foreground">–</span>
        <input type="month" data-testid={`${testidPrefix}-to`} value={to} onChange={(e) => onChange(from, e.target.value)} className="rounded-lg border border-input bg-background px-2 py-1 text-sm" />
      </div>
      {active ? <button data-testid={`${testidPrefix}-clear`} onClick={() => onChange("", "")} className="text-sm font-semibold text-primary">Clear</button> : null}
    </div>
  );
}
